export default {
    title_list: 'Administrators',
    title_page: 'Administrator',
    title_create_page: 'Create administrator',
    title_edit_page: 'Change admin',

    filter: {
        labels: {
            first_name: 'First name',
            last_name: 'Last name',
            email: 'Email',
        }
    },

    table: {
        labels: {
            id: 'ID',
            first_name: 'First name',
            last_name: 'Last name',
            email: 'Email',
        }
    },

    buttons: {

    },

    form: {
        first_name: 'First name',
        last_name: 'Last name',
        email: 'Email',
        password: 'Password',
        email_verified_at: 'Email confirmation date',
        last_login_at: 'Last entrance',
        language: 'Language',
        activated: 'Activated',
    },
}
